
const getCountryByTimezone = (timezone: string): string => {
  switch (timezone) {
    case "America/Lima":
      return "Perú";
    case "America/Santiago":
      return "Chile";
    default:
      return "";
  }
};

export { getCountryByTimezone };
